import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/paper-plane': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M440 6.5c34.6-19.9 77.6 8.8 71.5 48.9l-59.4 387.2c-2.3 14.5-11.1 27.3-23.9 34.5-7.3 4.1-15.4 6.2-23.6 6.2-6.2 0-12.4-1.2-18.3-3.6l-111.9-46.2-43.8 59.1c-27.4 36.9-86.6 17.8-86.6-28.6v-84.4l-114.3-47.3c-36.8-15.1-40.1-66-5.7-85.9zM192 464l36.6-49.5-36.6-15.1v64.6zM404.6 435.3l59.4-387.3-416 240 107.8 44.6 211.5-184.3c14.2-12.3 34.4 5.7 23.7 21.2l-140.2 202.3z'
      }
    ]
  }
})
